import React, { useMemo } from 'react';
import { Filter, FilterSelection } from '../Filters.style';
import { BodyStyleFrame } from './bodyStyle.style';
import { BodyTypeFilterResultCounts, FilterOption } from '../../../types';
import {
  ExposedFiltersTypes,
  FilterTypes,
  LIST_OF_BODY_TYPES,
} from '../../../constants/initialFilters';
import Body from './Body';
import FilterExposedHeader from '../FilterExposedHeader';
import useAnimations from '../../../hooks/Animations/useAnimations';

type BodyType = keyof BodyTypeFilterResultCounts;

interface BodyStyleTypes {
  filterType: string;
  bodyTypeOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;
  availableFilters: string[];
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const BodyStyle: React.FC<BodyStyleTypes> = ({
  filterType,
  bodyTypeOptions,
  confirmedFilters,
  openedFiltersList,
  handleAddFilter,
  handleExposeFilter,
  availableFilters,
}) => {
  const sortedBodyTypes = useMemo(() => {
    return availableFilters
      .sort((a, b) => {
        return LIST_OF_BODY_TYPES.indexOf(a) - LIST_OF_BODY_TYPES.indexOf(b);
      })
      .filter((toCheck) => toCheck !== '');
  }, [availableFilters]);

  const selectedBodyTypeLabels = useMemo(() => {
    const seletedBodyTypeList = confirmedFilters.bodyType;
    return seletedBodyTypeList.map((body) => bodyTypeOptions[body].label).join(', ');
  }, [bodyTypeOptions, confirmedFilters]);
  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter data-testid="filter-bodyType">
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedBodyTypeLabels}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      <>
        {dropdownAnimation(
          (props, item) =>
            item && (
              <FilterSelection style={props}>
                <BodyStyleFrame data-testid="bodyStyle-list" style={filtersAccordianAnimation}>
                  {sortedBodyTypes.map((body) => {
                    return (
                      <Body
                        key={body}
                        body={body as BodyType}
                        filterType={filterType}
                        bodyTypeOptions={bodyTypeOptions}
                        confirmedFilters={confirmedFilters}
                        availableFilters={availableFilters}
                        handleAddFilter={handleAddFilter}
                      />
                    );
                  })}
                </BodyStyleFrame>
              </FilterSelection>
            ),
        )}
      </>
    </Filter>
  );
};

export default BodyStyle;
